export enum LOCAL_STORAGE_KEYS {
  LAST_TIME_ME_WAS_FETCHED_ON_CLIENT_SIDE = "LAST_TIME_ME_WAS_FETCHED_ON_CLIENT_SIDE",
  OIDC_ID_TOKEN = "oidc.user",
  STORED_OIDC_SESSIONS = "STORED_OIDC_SESSIONS",
  UI_STATE = "UI_STATE",
}
